module.exports = __webpack_public_path__ + "img/fondo-banner-principal.ea3b1093.png";